const shimmer = `
  relative overflow-hidden
  before:absolute before:inset-0
  before:-translate-x-full
  before:animate-[shimmer_1.4s_infinite]
  before:bg-gradient-to-r
  before:from-transparent before:via-white/60 before:to-transparent
`

function SkeletonRow() {
  return (
    <div className="bg-white rounded-[14px] px-4 py-3 shadow-[0_2px_8px_rgba(44,24,16,0.06)]">
      {/* top row */}
      <div className="flex items-center gap-4.5 lg:gap-3 mb-6">
        {/* icon placeholder */}
        <div className={`w-12 h-12 lg:w-10 lg:h-10 rounded-[10px] bg-[#F2EDE4] shrink-0 ${shimmer}`} />
        {/* name + price */}
        <div className="flex-1 flex flex-col gap-1.5">
          <div className={`h-4.5 w-2/5 lg:h-3.5 lg:w-2/5 rounded-full bg-[#F2EDE4] ${shimmer}`} />
          <div className={`h-4 w-1/4 lg:h-3 lg:w-1/4 rounded-full bg-[#F2EDE4] ${shimmer}`} />
          <div className={`h-3 w-1/4 lg:h-3 lg:w-1/4 rounded-full bg-[#F2EDE4] ${shimmer}`} />
        </div>
        {/* status badge — desktop */}
        <div className={`hidden sm:block h-8 w-20 lg:h-6 lg:w-20 rounded-full bg-[#F2EDE4] shrink-0 ${shimmer}`} />
        {/* quantity — desktop */}
        <div className={`hidden sm:block h-8 w-16 lg:h-6 lg:w-16 rounded-lg bg-[#F2EDE4] shrink-0 ${shimmer}`} />
        {/* select — desktop */}
        <div className={`hidden sm:block h-9 w-28 lg:h-7 lg:w-28 rounded-[8px] bg-[#F2EDE4] shrink-0 ${shimmer}`} />
        {/* actions */}
        <div className="flex gap-2.5 lg:gap-1.5 shrink-0">
          <div className={`h-9 w-14 lg:h-7 lg:w-14 rounded-[8px] bg-[#F2EDE4] ${shimmer}`} />
          <div className={`h-9 w-10 lg:h-7 lg:w-10 rounded-[8px] bg-[#F2EDE4] ${shimmer}`} />
        </div>
      </div>
      {/* mobile bottom row */}
      <div className="flex sm:hidden items-center gap-3.5 lg:gap-2 mt-2 pt-2 border-t border-[#F2EDE4]">
        <div className={`h-8 w-16 rounded-full bg-[#F2EDE4] ${shimmer}`} />
        <div className={`h-9 flex-1 rounded-[8px] bg-[#F2EDE4] ${shimmer}`} />
        <div className={`h-6 w-10 rounded-full bg-[#F2EDE4] ${shimmer}`} />
      </div>
    </div>
  )
}

export default function AdminSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div
      className="flex flex-col gap-4 px-4 lg:px-0"
      aria-busy="true"
      aria-label="טוען מוצרים"
    >
      {Array.from({ length: rows }).map((_, i) => <SkeletonRow key={i} />)}
    </div>
  )
}
